/**
 * @file Submission UI — readonlyFormUtils.
 */

import type { FormField } from "../../interfaces/formInterfaces";
import type { FieldSchema } from "./readonlyFormDisplay";

/** Dataset Overview read-only fields should not show CMS info (i) tooltips. */
export function stripFieldInfoText<T extends FieldSchema | FormField>(field: T): T {
  return { ...field, infoText: undefined };
}
